
import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoggingService } from './logging.service';

@Injectable({ providedIn: 'root' })
export class UnhandledRejectionService {
  private snack = inject(MatSnackBar);
  private logger = inject(LoggingService);
  init() {
    window.addEventListener('unhandledrejection', (event) => {
      const reason: any = (event as any).reason;
      const message = reason?.message ?? String(reason);
      const stack = reason?.stack ? String(reason.stack) : undefined;
      const payload = { type: 'promise-unhandled', message, stack, url: location.href, when: new Date().toISOString() };
      this.snack.open('A background error occurred. Some actions may not have completed.', 'Dismiss', { duration: 5000 });
      this.logger.logClientError(payload).subscribe();
    });
  }
}
